export class VerifyRegisterCode {
  constructor(authApiClient) {
    this.authApiClient = authApiClient;
  }

  execute(payload) {
    return this.authApiClient.verifyRegisterCode(payload);
  }
}
